
import { Component, Vue, Prop } from "vue-property-decorator"

import SureViewIcon from "@/components/SureViewIcon.vue"

@Component({
	components: {
		"sv-icon": SureViewIcon
	}
})
export default class SkeletonLoader extends Vue {
	@Prop({ default: false })
	loading!: any;

	@Prop({ type: String, default: "md" })
	public size!: string;
}

